import React, { useState } from 'react';
import { ActionIcon, Menu, Stack, Text, Tooltip } from '@mantine/core';
import { IconHelp, IconKeyboard } from '@tabler/icons-react';
import { GanttRecalcEngineToggles } from './GanttRecalcEngineToggles';
import type { ScheduleRecalcEnginePreference } from '../../../gantt/scheduleRecalcEnginePreference';
import { GANTT_TOOLBAR_BUTTON_RADIUS } from './ganttToolbarStyles';

export interface GanttHelpMenuProps {
  recalcEngine: ScheduleRecalcEnginePreference;
  onRecalcEngineChange: (engine: ScheduleRecalcEnginePreference) => void;
  onOpenKeyboardShortcuts: () => void;
}

/** Icon-only temporary home for Engine + Help (keyboard shortcuts). */
export function GanttHelpMenu({
  recalcEngine,
  onRecalcEngineChange,
  onOpenKeyboardShortcuts,
}: GanttHelpMenuProps) {
  const [opened, setOpened] = useState(false);

  return (
    <Menu
      opened={opened}
      onChange={setOpened}
      shadow="md"
      radius="md"
      width={300}
      position="bottom-end"
      withinPortal
      closeOnItemClick={false}
    >
      <Menu.Target>
        <Tooltip label="Help and schedule engine" withArrow>
          <ActionIcon
            variant="default"
            size={28}
            radius={GANTT_TOOLBAR_BUTTON_RADIUS}
            type="button"
            aria-label="Help"
            aria-expanded={opened}
          >
            <IconHelp size={15} stroke={1.75} />
          </ActionIcon>
        </Tooltip>
      </Menu.Target>
      <Menu.Dropdown p="sm">
        <Stack gap="sm">
          <div>
            <Text size="xs" fw={700} c="dimmed" tt="uppercase" mb={6}>
              Engine
            </Text>
            <GanttRecalcEngineToggles
              value={recalcEngine}
              onChange={onRecalcEngineChange}
            />
          </div>
          <Menu.Divider />
          <Menu.Item
            leftSection={<IconKeyboard size={14} stroke={1.6} />}
            onClick={() => {
              onOpenKeyboardShortcuts();
              setOpened(false);
            }}
          >
            <Text size="sm" fw={600}>
              Keyboard shortcuts
            </Text>
            <Text size="xs" c="dimmed">
              Navigation and editing shortcuts for the Gantt chart.
            </Text>
          </Menu.Item>
        </Stack>
      </Menu.Dropdown>
    </Menu>
  );
}
